/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Transaction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import EntityType from './EntityType/index'
import LineToNextPoint from './LineToNextPoint/index'
import Notes from './Notes/index'
import Point from './Point/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Transaction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction"
  
}) {
let entryItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isLast',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Transaction.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Point
  viewPath={`${viewPath}/Point`}
/>
<LineToNextPoint
  viewPath={`${viewPath}/LineToNextPoint`}
/>
<div
  data-testid="Transaction.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-1-Zz5uoM': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-2-Zz5uoM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-3-Zz5uoM': !entryItemIsLastValueData ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px"}}
 className={`views-block ${styles.Horizontal1}`}
>
<EntityType
  viewPath={`${viewPath}/EntityType`}
/>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</div>
</div>
{children}
</React.Fragment>)
}